import { useEffect, useState } from "react";
import type { MLAsset } from "@dealer-center/ddc-pages-alt-text-manager-interface";

interface UseImagePaginationParams {
  filteredImages: MLAsset[];
  pageSize: number;
  resetTrigger: string | number | boolean;
}

/**
 * Custom hook for managing image pagination state and calculations
 * Automatically resets to page 1 when resetTrigger changes
 */
export const useImagePagination = ({
  filteredImages,
  pageSize,
  resetTrigger
}: UseImagePaginationParams) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(filteredImages.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const imagesOnPage = filteredImages.slice(startIndex, endIndex);

  // Reset to page 1 when filter toggle changes to prevent empty pages
  useEffect(() => {
    setCurrentPage(1);
  }, [resetTrigger]);

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    imagesOnPage
  };
};
